<template>
  <transition :name="transitionName">
    <div
      v-show="visible"
      class="back-to-ceiling"
      @click="backToTop">
      <svg
        t="1584331218793"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="11738">
        <path
          d="M512 1024C229.2224 1024 0 794.7776 0 512S229.2224 0 512 0s512 229.2224 512 512-229.2224 512-512 512z m-8.96-815.3088l-191.6672 178.2528a12.6208 12.6208 0 0 0 0 18.7648c5.5808 5.1968 14.592 5.1968 20.1728 0l182.2976-169.5744 179.3024 166.784a14.592 14.592 0 0 0 19.584 0 12.2368 12.2368 0 0 0 0-18.2272L526.5408 211.456c-0.7168-0.6656-1.6128-1.024-2.4576-1.5104-0.3072-0.4096-0.512-0.896-0.896-1.28a15.0272 15.0272 0 0 0-20.1728 0z m-163.6864 295.936v21.504H404.48c-0.9216 11.0592-2.1504 21.8112-3.9936 32.256h-52.224v146.2272h21.504v-125.6448h93.0816V704h21.8112v-145.6128H422.912c1.8432-10.4448 3.072-21.1968 3.9936-32.256h67.8912v-21.504h-155.4432z m101.9904 201.216l-15.0528 14.1312c23.3472 19.0464 41.472 36.864 54.9888 53.4528l15.9744-16.2816c-15.0528-17.2032-33.792-34.0992-55.9104-51.3024z m-37.1712-108.7488v54.6816c-0.9216 26.112-7.3728 47.3088-19.6608 63.5904-12.9024 15.6672-35.6352 28.2624-68.5056 37.7856l11.9808 18.7392c34.0992-10.4448 58.6752-24.576 73.728-42.3936 15.36-19.0464 23.3472-45.1584 24.2688-77.7216v-54.6816h-21.8112z m-138.8544 172.032c17.5104 0 26.4192-9.216 26.4192-27.3408v-215.6544h36.864v-21.504H221.696v21.504h47.3088v210.1248c0 8.6016-3.9936 13.2096-11.3664 13.2096-10.1376 0-20.8896-0.6144-31.9488-1.2288l4.9152 20.8896h34.7136z m304.4352-215.04l-20.2752 7.3728c7.68 13.5168 14.1312 28.2624 19.6608 44.2368h-41.472v21.504h153.9072v-21.504h-37.1712c7.9872-13.824 15.0528-29.4912 21.504-47.0016l-20.5824-7.0656c-6.144 19.0464-13.824 37.1712-22.7328 54.0672h-32.256a300.2624 300.2624 0 0 0-20.5824-51.6096z m125.952-49.7664v268.1856h21.504v-247.9104h54.9888a860.8 860.8 0 0 1-30.1056 86.3232c23.9616 29.4912 36.2496 53.1456 36.5568 71.2704-0.3072 11.0592-1.8432 18.432-4.9152 22.4256-3.072 3.6864-10.1376 5.8368-21.1968 6.4512-5.8368 0-12.9024-0.6144-21.504-1.2288l7.0656 23.3472c25.1904 0 42.0864-3.9936 50.688-11.3664 7.9872-7.3728 11.9808-20.5824 11.9808-39.6288-0.3072-18.432-11.9808-42.3936-35.0208-71.2704 11.0592-27.648 21.1968-57.7536 30.72-90.0096V504.32h-100.7616z m-162.2016 16.896v21.504h145.92v-21.504h-62.6688a489.5232 489.5232 0 0 0-10.1376-31.6416l-22.7328 3.9936c3.9936 8.2944 7.68 17.5104 11.3664 27.648H533.504z m133.9392 133.9392h-122.2656v115.8144h21.8112v-17.2032h78.6432v17.2032h21.8112v-115.8144z m-100.4544 77.7216v-56.832h78.6432v56.832h-78.6432z"
          fill="#4A4A4A"
          fill-opacity=".6"
          p-id="11739" />
      </svg>
    </div>
  </transition>
</template>

<script>
    export default {
        name: 'BackToTop',
        props: {
            visibilityHeight: {
                type: Number,
                default: 400
            },
            backPosition: {
                type: Number,
                default: 0
            },
            transitionName: {
                type: String,
                default: 'fade'
            }
        },
        data() {
            return {
                visible: false,
                interval: null,
                isMoving: false
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
        },
        activated() {
            window.addEventListener('scroll', this.handleScroll)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll)
            if (this.interval) {
                clearInterval(this.interval)
            }
        },
        deactivated() {
            window.removeEventListener('scroll', this.handleScroll)
            if (this.interval) {
                clearInterval(this.interval)
            }
        },
        methods: {
            handleScroll() {
                this.visible = window.pageYOffset > this.visibilityHeight;
                this.$emit('scroll', window.pageYOffset);
            },
            backToTop() {
                if (this.isMoving) return
                const start = window.pageYOffset
                let i = 0
                this.isMoving = true
                this.interval = setInterval(() => {
                    const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
                    if (next <= this.backPosition) {
                        window.scrollTo(0, this.backPosition)
                        clearInterval(this.interval)
                        this.isMoving = false
                    } else {
                        window.scrollTo(0, next)
                    }
                    i++
                }, 16.7)
            },
            easeInOutQuad(t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t + b
                return -c / 2 * (--t * (t - 2) - 1) + b
            }
        }
    }
</script>

<style scoped>
  .back-to-ceiling {
    position: fixed;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    right: 0.5rem;
    bottom: 2rem;
    width: 1rem;
    height: 1rem;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/BackToTop/index.vue